import Logo from '../logos/airflowsim';

export default Logo;
